import { render, staticRenderFns } from "./registerComplete.vue?vue&type=template&id=46bb8354&scoped=true"
import script from "./registerComplete.vue?vue&type=script&lang=js"
export * from "./registerComplete.vue?vue&type=script&lang=js"
import style0 from "./registerComplete.vue?vue&type=style&index=0&id=46bb8354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb8354",
  null
  
)

export default component.exports